var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { ELSLoggingService } from '@els/els-ui-common-react';
import { AppConstant, HESI_EXAM } from 'constants/app.constant';
import { find, isEmpty } from 'lodash';
import { SystemType } from 'models/user-management';
import moment from 'moment';
import { generatePath } from 'react-router';
import { createAction, handleActions } from 'redux-actions';
import { PerformancePath } from 'reports/cw/constants/cw.constant';
import { HAD_PATHS } from 'reports/had/constants/had.constant';
import { hadActions } from 'reports/had/redux/ducks/had';
import { fetchCohortsByProgramIds, fetchCohortStudents } from 'reports/had/services/had.service';
import { fetchCatalogs } from 'reports/ps/services/ps.service';
import { SH_ROLE } from 'reports/sh/constants/sh.constant';
import { shActions } from 'reports/sh/redux/ducks/sh';
import { getSHUsersFromEvolveUsername } from 'reports/sh/services/sh.service';
import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { fetchAllEolsUserByEolsUserId, fetchCrosswalkUser, fetchExternalUserInfo } from 'services/user-management.service';
var initialState = Immutable({
    actionsInProgress: [],
    breadcrumbBackTitle: '',
    loggedInUser: null,
    evolveUser: null,
    userRole: '',
    courses: [],
    cwCourses: [],
    selectedCourse: null,
    courseSectionRoles: [],
    appLoading: false,
    evolveUserLoading: false,
    evolveUserHasBeenCalled: false,
    eaqTopicMappedHesiExam: [],
    eaqTopicMappedHesiExamByCourseId: {},
    eaqTopicMappedHesiExamByISBN: {},
    isEaqTopicMappedHesiExamLoading: false,
    isBackToPreviousAppIconShown: false,
    redirectUrl: null,
    eaqTopicPerformanceUrl: null,
    linkId: null,
    featureFlags: [],
    isLaunchedFromAnotherApp: false,
    isFeatureFlagsLoading: true,
    isCWLinkHADAndEHRChecking: false,
    isCWBentoBoxLinkShow: false,
    isCWBentoBoxLinkLoading: false,
    isHADStudentDetailLinkShow: false,
    isCWStudentDetailLinkShow: false,
    isHADStudentDetailLinkFetching: true,
    isCWStudentDetailLinkFetching: true,
    hadStudentDetailLink: '',
    cwStudentDetailLink: '',
    isCWSubNavInEHRPageShow: false,
    appLinkOutPostBody: null,
    appLinkNavigationInfo: null,
    userId: null,
    bentoBoxShown: true,
    evolveUsername: null,
    isEhrReportingEnabled: false,
    isNclexReportingEnabled: false,
    isProgramSolutionsEnabled: false,
    isEmergePackageEnabled: false,
    isLaunchedInNewTab: false,
    selectedExpandRowId: null,
    toggleExpandRowId: null,
    allEolsUsers: null,
    catalog: [],
    assignments: [],
    isAllAADataCollected: false,
    customizationScore: null,
    ecrId: null,
    userEnhancedRoles: []
});
var setAwait = createAction('APP/AWAIT');
var cleanAwait = createAction('APP/AWAIT_CLEAN');
var doNothing = createAction('APP/EMPTY_ACTION');
var restoreState = createAction('APP/RESTORE');
var setLoggedInUser = createAction('APP/SET_LOGGED_IN_USER');
var setUserRole = createAction('APP/SET_USER_ROLE');
var setIsbn = createAction('APP/SET_ISBN');
var setCourses = createAction('APP/SET_COURSES');
var setCWCourses = createAction('APP/SET_CW_COURSES');
var setSelectedCourse = createAction('APP/SET_SELECTED_COURSE');
var setCourseSectionRoles = createAction('APP/SET_COURSE_ROLES');
var setAppLoading = createAction('APP/SET_APP_LOADING');
var setEvolveUserLoading = createAction('APP/SET_EVOLVE_USER_LOADING');
var setEAQTopicMappedHesiExam = createAction('APP/SET_EAQ_TOPIC_MAPPED_HESI_EXAM');
var setEAQTopicMappedHesiExamByCourseId = createAction('APP/SET_EAQ_TOPIC_MAPPED_HESI_EXAM_BY_COURSE_ID');
var setEaqTopicMappedHesiExamByISBN = createAction('APP/SET_EAQ_TOPIC_MAPPED_HESI_EXAM_BY_ISBN');
var setIsEAQTopicMappedHesiExamLoading = createAction('APP/SET_IS_EAQ_TOPIC_MAPPED_HESI_EXAM_LOADING');
var setIsBackToPreviousAppIconShown = createAction('APP/SET_IS_BACK_TO_PREVIOUS_APP_ICON_SHOWN');
var setRedirectUrl = createAction('APP/SET_REDIRECT_URL');
var setEaqTopicReportUrl = createAction('APP/SET_EAQ_TOPIC_REPORT_URL');
var setLinkId = createAction('APP/SET_LINK_ID');
var setFeatureFlags = createAction('APP/SET_FEATURE_FLAGS');
var setEvolveUser = createAction('APP/SET_EVOLVE_USER');
var setEvolveUserHasBeenCalled = createAction('APP/EVOLVE_USER_HAS_BEEN_CALLED');
var setIsFeatureFlagsLoading = createAction('APP/SET_IS_FEATURE_FLAGS_LOADING');
var setIsLaunchedFromAnotherApp = createAction('APP/SET_IS_LAUNCHED_FROM_ANOTHER_APP');
var setIsCWLinkHADAndEHRChecking = createAction('APP/SET_IS_CW_LINK_HAD_AND_EHR_CHECKING');
var setIsCWBentoBoxLinkShow = createAction('APP/SET_IS_CW_BENTO_BOX_LINK_SHOW');
var setIsCWBentoBoxLinkLoading = createAction('APP/SET_IS_CW_BENTO_BOX_LINK_LOADING');
var setIsHADStudentDetailLinkShow = createAction('APP/SET_IS_HAD_STUDENT_DETAIL_LINK_SHOW');
var setIsCWStudentDetailLinkShow = createAction('APP/SET_IS_CW_STUDENT_DETAIL_LINK_SHOW');
var setIsHADStudentDetailLinkFetching = createAction('APP/SET_IS_HAD_STUDENT_DETAIL_LINK_FETCHING');
var setIsCWStudentDetailLinkFetching = createAction('APP/SET_IS_CW_STUDENT_DETAIL_LINK_FETCHING');
var setIsCWSubNavInEHRPageShow = createAction('APP/SET_IS_CW_SUB_NAV_IN_EHR_PAGE_SHOW');
var setHADStudentDetailLink = createAction('APP/SET_HAD_STUDENT_DETAIL_LINK');
var setCWStudentDetailLink = createAction('APP/SET_CW_STUDENT_DETAIL_LINK');
var setAppLinkOutPostBody = createAction('APP/SET_APP_LINK_OUT_POST_BODY');
var setAppLinkNavigationInfo = createAction('APP/SET_APP_LINK_NAVIGATION_INFO');
var setUserId = createAction('APP/SET_USER_ID');
var setActiveUserId = createAction('APP/SET_ACTIVE_USER_ID');
var setBentoBoxShown = createAction('APP/SET_BENTO_BOX_SHOWN');
var setEvolveUsername = createAction('APP/SET_EVOLVE_USERNAME');
var setBreadcrumbBackTitle = createAction('APP/SET_BREADCRUMB_BACK_TITLE');
var setIsEhrReportingEnabled = createAction('APP/SET_IS_EHR_REPORTING_ENABLED');
var setIsNclexReportingEnabled = createAction('APP/SET_IS_NCLEX_REPORTING_ENABLED');
var setIsShEnabled = createAction('APP/SET_IS_SH_ENABLED');
var setIsProgramSolutionsEnabled = createAction('APP/SET_IS_PROGRAM_SOLUTIONS_ENABLED');
var setIsEmergePackageEnabled = createAction('APP/SET_IS_EMERGE_PACKAGE_ENABLED');
var setIsLaunchedInNewTab = createAction('APP/SET_IS_LAUNCHED_IN_NEW_TAB');
var setSelectedExpandRowId = createAction('APP/SET_SELECTED_EXPAND_ROW_ID');
var setToggleExpandRowId = createAction('APP/SET_TOGGLE_EXPAND_ROW_ID');
var setAllEolsUsers = createAction('APP/SET_ALL_EOLS_USERS');
var setCatalog = createAction('APP/SET_CATALOG');
var setAssignments = createAction('APP/SET_ASSIGNMENTS');
var setIsAllAADataCollected = createAction('APP/SET_IS_ALL_AA_DATA_COLLECTED');
var setCustomizationScore = createAction('APP/SET_CUSTOMIZATION_SCORE');
var setEcrId = createAction('APP/SET_ECR_ID');
var setUserEnhancedRoles = createAction('APP/SET_USER_ENHANCED_ROLES');
var fetchSHInstructorId = function (evolveUsername, eolsUserId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var evolveUsrn, data_1, data, _a, id, role;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                evolveUsrn = evolveUsername;
                if (!!evolveUsrn) return [3 /*break*/, 2];
                return [4 /*yield*/, fetchCrosswalkUser(eolsUserId, SystemType.EVOLVETYPE)];
            case 1:
                data_1 = (_b.sent()).data;
                evolveUsrn = data_1.userName;
                _b.label = 2;
            case 2: return [4 /*yield*/, getSHUsersFromEvolveUsername(evolveUsrn)];
            case 3:
                data = (_b.sent()).data.data;
                if (data.length) {
                    _a = data[0], id = _a.id, role = _a.role;
                    if (role === SH_ROLE.INSTRUCTOR) {
                        dispatch(shActions.setInstructorId(id));
                    }
                }
                return [2 /*return*/];
        }
    });
}); }; };
var fetchEvolveUser = function (userId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var crosswalkUser, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, 3, 4]);
                dispatch(setEvolveUserLoading(true));
                return [4 /*yield*/, fetchCrosswalkUser(userId, SystemType.EVOLVETYPE)];
            case 1:
                crosswalkUser = _a.sent();
                dispatch(setEvolveUser(crosswalkUser.data));
                return [3 /*break*/, 4];
            case 2:
                err_1 = _a.sent();
                ELSLoggingService.error('app.ts', "Failed to fetchEvolveUser: ".concat(err_1.message));
                return [3 /*break*/, 4];
            case 3:
                dispatch(setEvolveUserLoading(false));
                // prevent repeated calls if error
                dispatch(setEvolveUserHasBeenCalled(true));
                return [7 /*endfinally*/];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var checkStudentHasHADData = function (studentId, programs) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var programId, _a, cohortsByProgramIdsRes, crosswalkUserRes, cohort, cohortId, evolveUserName_1, isStudentHasHADData, path, originPath, e_1;
    var _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 6, 7, 8]);
                dispatch(setIsHADStudentDetailLinkFetching(true));
                dispatch(setIsHADStudentDetailLinkShow(true));
                programId = programs[0].programId;
                return [4 /*yield*/, Promise.all([fetchCohortsByProgramIds([programId]), fetchCrosswalkUser(studentId, SystemType.EVOLVETYPE)])];
            case 1:
                _a = _e.sent(), cohortsByProgramIdsRes = _a[0], crosswalkUserRes = _a[1];
                cohort = (_c = (_b = cohortsByProgramIdsRes.data) === null || _b === void 0 ? void 0 : _b.sort(function (a, b) { return moment(a.cohortGraduationDate).diff(moment(b.cohortGraduationDate)); })) === null || _c === void 0 ? void 0 : _c.pop();
                cohortId = cohort.cohortId;
                evolveUserName_1 = (_d = crosswalkUserRes.data) === null || _d === void 0 ? void 0 : _d.userName;
                return [4 /*yield*/, fetchCohortStudents(cohortId).then(function (res) { return res.data.filter(function (student) { return (student === null || student === void 0 ? void 0 : student.evolveUserName) === evolveUserName_1; }).length; })];
            case 2:
                isStudentHasHADData = _e.sent();
                if (!isStudentHasHADData) return [3 /*break*/, 4];
                path = generatePath(HAD_PATHS.studentDetail, { cohortId: cohortId.toString(), evolveUserName: evolveUserName_1 });
                originPath = { pathname: generatePath(HAD_PATHS.cohortDetail, { cohortId: cohortId.toString() }), hash: 'byStudent' };
                dispatch(setIsHADStudentDetailLinkShow(true));
                dispatch(setHADStudentDetailLink(path));
                dispatch(hadActions.setStudentDetailOriginPath(originPath));
                dispatch(hadActions.setSelectedCohort(cohort));
                dispatch(hadActions.setProgramId(programId));
                dispatch(hadActions.setIsStudentMultipleCohortEnabled(true));
                return [4 /*yield*/, dispatch(hadActions.fetchCategoryGroupListData(cohortId))];
            case 3:
                _e.sent();
                return [3 /*break*/, 5];
            case 4:
                dispatch(setIsHADStudentDetailLinkShow(false));
                dispatch(setHADStudentDetailLink(''));
                _e.label = 5;
            case 5: return [3 /*break*/, 8];
            case 6:
                e_1 = _e.sent();
                dispatch(setIsHADStudentDetailLinkShow(false));
                dispatch(setHADStudentDetailLink(''));
                ELSLoggingService.error('app.ts', "checkStudentHasHADData: ".concat(e_1.message));
                return [3 /*break*/, 8];
            case 7:
                dispatch(setIsHADStudentDetailLinkFetching(false));
                return [7 /*endfinally*/];
            case 8: return [2 /*return*/];
        }
    });
}); }; };
export var checkStudentHasCWData = function (evolveUsername) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var eolsUser, userId, response, allEolsUsersData, allStudentEolsIds, allStudentCWCourses, e_2;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, 4, 5]);
                dispatch(setIsCWStudentDetailLinkFetching(true));
                dispatch(setIsCWStudentDetailLinkShow(true));
                return [4 /*yield*/, fetchExternalUserInfo(evolveUsername)];
            case 1:
                eolsUser = _c.sent();
                userId = (_b = (_a = eolsUser === null || eolsUser === void 0 ? void 0 : eolsUser.data) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString();
                return [4 /*yield*/, fetchAllEolsUserByEolsUserId(userId, SystemType.EVOLVETYPE)];
            case 2:
                response = _c.sent();
                allEolsUsersData = response.data;
                allStudentEolsIds = allEolsUsersData.flatMap(function (user) { return user.id; });
                allStudentCWCourses = allEolsUsersData.flatMap(function (user) { return user.courseSections; }).filter(function (course) { return course.entitlements.length > 0 && course.gradeSyncVersion !== null; });
                if (allStudentCWCourses) {
                    dispatch(setCWCourses(allStudentCWCourses));
                    dispatch(setIsCWStudentDetailLinkShow(true));
                    // use the first eols id with entitlements so there is a default link to Sherpath student detail
                    dispatch(setCWStudentDetailLink(generatePath(PerformancePath.studentDetail, { studentId: allStudentEolsIds[0].toString() })));
                }
                else {
                    dispatch(setIsCWStudentDetailLinkShow(false));
                    dispatch(setCWStudentDetailLink(''));
                }
                return [3 /*break*/, 5];
            case 3:
                e_2 = _c.sent();
                dispatch(setIsCWStudentDetailLinkShow(false));
                dispatch(setCWStudentDetailLink(''));
                return [3 /*break*/, 5];
            case 4:
                dispatch(setIsCWStudentDetailLinkFetching(false));
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var checkEHREnabled = function (courseSectionId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var appState, _a, courses, _b, courseSectionInfo, entitlements, isbns, data, e_3;
    var _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 3, , 4]);
                appState = getState()[AppConstant.reduxResources.APP_STATE];
                _a = appState.courses, courses = _a === void 0 ? [] : _a;
                _b = getState()[AppConstant.reduxResources.COURSES_STATE].courseSectionInfo, courseSectionInfo = _b === void 0 ? {} : _b;
                entitlements = (isEmpty(courseSectionInfo) ? find(courses, { id: courseSectionId }) : courseSectionInfo).entitlements;
                if (!(entitlements && entitlements.length > 0)) return [3 /*break*/, 2];
                isbns = entitlements.map(function (etm) { return etm.isbn; });
                return [4 /*yield*/, fetchCatalogs(isbns, HESI_EXAM)];
            case 1:
                data = (_e.sent()).data;
                if (data && ((_d = (_c = data === null || data === void 0 ? void 0 : data.catalog) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                    dispatch(setIsEhrReportingEnabled(true));
                }
                else {
                    dispatch(setIsEhrReportingEnabled(false));
                }
                _e.label = 2;
            case 2: return [3 /*break*/, 4];
            case 3:
                e_3 = _e.sent();
                ELSLoggingService.error('app.ts', "checkIsEHREnable: ".concat(e_3.message));
                dispatch(setIsEhrReportingEnabled(false));
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
var actions = {
    setAwait: setAwait,
    checkStudentHasHADData: checkStudentHasHADData,
    checkStudentHasCWData: checkStudentHasCWData,
    checkEHREnabled: checkEHREnabled,
    cleanAwait: cleanAwait,
    doNothing: doNothing,
    restoreState: restoreState,
    setLoggedInUser: setLoggedInUser,
    setUserRole: setUserRole,
    setIsbn: setIsbn,
    setCourses: setCourses,
    setCWCourses: setCWCourses,
    setSelectedCourse: setSelectedCourse,
    setCourseSectionRoles: setCourseSectionRoles,
    setAppLoading: setAppLoading,
    setEvolveUserLoading: setEvolveUserLoading,
    setEvolveUserHasBeenCalled: setEvolveUserHasBeenCalled,
    setEAQTopicMappedHesiExam: setEAQTopicMappedHesiExam,
    setEAQTopicMappedHesiExamByCourseId: setEAQTopicMappedHesiExamByCourseId,
    setEaqTopicMappedHesiExamByISBN: setEaqTopicMappedHesiExamByISBN,
    setIsEAQTopicMappedHesiExamLoading: setIsEAQTopicMappedHesiExamLoading,
    setIsBackToPreviousAppIconShown: setIsBackToPreviousAppIconShown,
    setRedirectUrl: setRedirectUrl,
    setEaqTopicReportUrl: setEaqTopicReportUrl,
    setLinkId: setLinkId,
    setFeatureFlags: setFeatureFlags,
    setEvolveUser: setEvolveUser,
    setIsLaunchedFromAnotherApp: setIsLaunchedFromAnotherApp,
    setIsFeatureFlagsLoading: setIsFeatureFlagsLoading,
    setIsCWLinkHADAndEHRChecking: setIsCWLinkHADAndEHRChecking,
    setIsCWBentoBoxLinkShow: setIsCWBentoBoxLinkShow,
    setIsCWBentoBoxLinkLoading: setIsCWBentoBoxLinkLoading,
    setIsHADStudentDetailLinkShow: setIsHADStudentDetailLinkShow,
    setIsCWStudentDetailLinkShow: setIsCWStudentDetailLinkShow,
    setIsCWSubNavInEHRPageShow: setIsCWSubNavInEHRPageShow,
    setIsHADStudentDetailLinkFetching: setIsHADStudentDetailLinkFetching,
    setIsCWStudentDetailLinkFetching: setIsCWStudentDetailLinkFetching,
    setHADStudentDetailLink: setHADStudentDetailLink,
    setCWStudentDetailLink: setCWStudentDetailLink,
    setAppLinkOutPostBody: setAppLinkOutPostBody,
    setAppLinkNavigationInfo: setAppLinkNavigationInfo,
    fetchEvolveUser: fetchEvolveUser,
    setUserId: setUserId,
    setActiveUserId: setActiveUserId,
    setBentoBoxShown: setBentoBoxShown,
    setEvolveUsername: setEvolveUsername,
    fetchSHInstructorId: fetchSHInstructorId,
    setBreadcrumbBackTitle: setBreadcrumbBackTitle,
    setIsEhrReportingEnabled: setIsEhrReportingEnabled,
    setIsNclexReportingEnabled: setIsNclexReportingEnabled,
    setIsShEnabled: setIsShEnabled,
    setIsProgramSolutionsEnabled: setIsProgramSolutionsEnabled,
    setIsEmergePackageEnabled: setIsEmergePackageEnabled,
    setIsLaunchedInNewTab: setIsLaunchedInNewTab,
    setSelectedExpandRowId: setSelectedExpandRowId,
    setToggleExpandRowId: setToggleExpandRowId,
    setAllEolsUsers: setAllEolsUsers,
    setCatalog: setCatalog,
    setAssignments: setAssignments,
    setIsAllAADataCollected: setIsAllAADataCollected,
    setCustomizationScore: setCustomizationScore,
    setEcrId: setEcrId,
    setUserEnhancedRoles: setUserEnhancedRoles
};
var reducer = handleActions((_a = {},
    _a[actions.setAwait] = function (state, _a) {
        var isLoading = _a.payload.isLoading, meta = _a.meta;
        var actionsInProgress = state.actionsInProgress;
        if (isLoading) {
            actionsInProgress = __spreadArray(__spreadArray([], actionsInProgress, true), [meta], false);
        }
        else {
            var index = actionsInProgress.findIndex(function (item) { return item.actionType === meta.actionType; });
            actionsInProgress = __spreadArray(__spreadArray([], actionsInProgress.slice(0, index), true), actionsInProgress.slice(index + 1), true);
        }
        return state.set('actionsInProgress', actionsInProgress);
    },
    _a[actions.cleanAwait] = function (state) { return state.set('actionsInProgress', []); },
    _a[actions.restoreState] = function (state, _a) {
        var payload = _a.payload;
        return state.merge(payload);
    },
    _a[actions.setLoggedInUser] = function (state, _a) {
        var payload = _a.payload;
        return state.set('loggedInUser', payload);
    },
    _a[actions.setUserRole] = function (state, _a) {
        var payload = _a.payload;
        return state.set('userRole', payload);
    },
    _a[actions.setIsbn] = function (state, _a) {
        var payload = _a.payload;
        return state.set('isbn', payload);
    },
    _a[actions.setCourses] = function (state, _a) {
        var payload = _a.payload;
        return state.set('courses', payload);
    },
    _a[actions.setCWCourses] = function (state, _a) {
        var payload = _a.payload;
        return state.set('cwCourses', payload);
    },
    _a[actions.setSelectedCourse] = function (state, _a) {
        var payload = _a.payload;
        return state.set('selectedCourse', payload);
    },
    _a[actions.setCourseSectionRoles] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'courseSectionRoles', payload.data);
    },
    _a[actions.setAppLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'appLoading', payload);
    },
    _a[actions.setEvolveUserLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'evolveUserLoading', payload);
    },
    _a[actions.setEvolveUserHasBeenCalled] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'evolveUserHasBeenCalled', payload);
    },
    _a[actions.setEAQTopicMappedHesiExamByCourseId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'eaqTopicMappedHesiExamByCourseId', payload);
    },
    _a[actions.setEaqTopicMappedHesiExamByISBN] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'eaqTopicMappedHesiExamByISBN', payload);
    },
    _a[actions.setEAQTopicMappedHesiExam] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'eaqTopicMappedHesiExam', payload);
    },
    _a[actions.setIsEAQTopicMappedHesiExamLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isEaqTopicMappedHesiExamLoading', payload);
    },
    _a[actions.setIsBackToPreviousAppIconShown] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isBackToPreviousAppIconShown', payload);
    },
    _a[actions.setRedirectUrl] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'redirectUrl', payload);
    },
    _a[actions.setEaqTopicReportUrl] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'eaqTopicReportUrl', payload);
    },
    _a[actions.setLinkId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'linkId', payload);
    },
    _a[actions.setFeatureFlags] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'featureFlags', payload);
    },
    _a[actions.setIsFeatureFlagsLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isFeatureFlagsLoading', payload);
    },
    _a[actions.setEvolveUser] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'evolveUser', payload);
    },
    _a[actions.setIsLaunchedFromAnotherApp] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isLaunchedFromAnotherApp', payload);
    },
    _a[actions.setIsCWBentoBoxLinkShow] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCWBentoBoxLinkShow', payload);
    },
    _a[actions.setIsCWBentoBoxLinkLoading] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCWBentoBoxLinkLoading', payload);
    },
    _a[actions.setIsCWLinkHADAndEHRChecking] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCWLinkHADAndEHRChecking', payload);
    },
    _a[actions.setIsHADStudentDetailLinkShow] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isHADStudentDetailLinkShow', payload);
    },
    _a[actions.setIsCWStudentDetailLinkShow] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCWStudentDetailLinkShow', payload);
    },
    _a[actions.setIsHADStudentDetailLinkFetching] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isHADStudentDetailLinkFetching', payload);
    },
    _a[actions.setIsCWStudentDetailLinkFetching] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCWStudentDetailLinkFetching', payload);
    },
    _a[actions.setIsCWSubNavInEHRPageShow] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCWSubNavInEHRPageShow', payload);
    },
    _a[actions.setHADStudentDetailLink] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'hadStudentDetailLink', payload);
    },
    _a[actions.setCWStudentDetailLink] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'cwStudentDetailLink', payload);
    },
    _a[actions.setAppLinkOutPostBody] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'appLinkOutPostBody', payload);
    },
    _a[actions.setAppLinkNavigationInfo] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'appLinkNavigationInfo', payload);
    },
    _a[actions.setUserId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'userId', payload);
    },
    _a[actions.setActiveUserId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'userId', payload);
    },
    _a[actions.setBentoBoxShown] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'bentoBoxShown', payload);
    },
    _a[actions.setEvolveUsername] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'evolveUsername', payload);
    },
    _a[actions.setBreadcrumbBackTitle] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'breadcrumbBackTitle', payload);
    },
    _a[actions.setIsEhrReportingEnabled] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isEhrReportingEnabled', payload);
    },
    _a[actions.setIsNclexReportingEnabled] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isNclexReportingEnabled', payload);
    },
    _a[actions.setIsShEnabled] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isShEnabled', payload);
    },
    _a[actions.setIsProgramSolutionsEnabled] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isProgramSolutionsEnabled', payload);
    },
    _a[actions.setIsEmergePackageEnabled] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isEmergePackageEnabled', payload);
    },
    _a[actions.setIsLaunchedInNewTab] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isLaunchedInNewTab', payload);
    },
    _a[actions.setSelectedExpandRowId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'selectedExpandRowId', payload);
    },
    _a[actions.setToggleExpandRowId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'toggleExpandRowId', payload);
    },
    _a[actions.setAllEolsUsers] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'allEolsUsers', payload);
    },
    _a[actions.setCatalog] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'catalog', payload);
    },
    _a[actions.setAssignments] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'assignments', payload);
    },
    _a[actions.setIsAllAADataCollected] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isAllAADataCollected', payload);
    },
    _a[actions.setCustomizationScore] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'customizationScore', payload);
    },
    _a[actions.setEcrId] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'ecrId', payload);
    },
    _a[actions.setUserEnhancedRoles] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'userEnhancedRoles', payload);
    },
    _a), initialState);
var getAppState = function (state) { return state[AppConstant.reduxResources.APP_STATE]; };
export var getUserId = function (state) { return state.getIn(['loggedInUser', 'userId']) || state.getIn(['loggedInUser', 'id']) || state.userId; };
var selectors = {
    getAwaitingStatus: createSelector(getAppState, function (state) { return state.actionsInProgress.length > 0; }),
    getLoggedInUser: createSelector(getAppState, function (state) { return state.loggedInUser; }),
    getEvolveUser: createSelector(getAppState, function (state) { return state.evolveUser; }),
    getUserId: createSelector(getAppState, getUserId),
    getActiveUserId: createSelector(getAppState, getUserId),
    getUserRole: createSelector(getAppState, function (state) { return state.userRole; }),
    getIsbn: createSelector(getAppState, function (state) { return state.isbn; }),
    getCourses: createSelector(getAppState, function (state) { return state.courses; }),
    getCWCourses: createSelector(getAppState, function (state) { return state.cwCourses; }),
    getSelectedCourse: createSelector(getAppState, function (state) { return state.selectedCourse; }),
    getCourseSectionRoles: createSelector(getAppState, function (state) { return state.courseSectionRoles; }),
    getAppLoading: createSelector(getAppState, function (state) { return state.appLoading; }),
    getEvolveUserLoading: createSelector(getAppState, function (state) { return state.evolveUserLoading; }),
    getEvolveUserHasBeenCalled: createSelector(getAppState, function (state) { return state.evolveUserHasBeenCalled; }),
    getEAQTopicMappedHesiExam: createSelector(getAppState, function (state) { return state.eaqTopicMappedHesiExam; }),
    getEAQTopicMappedHesiExamByCourseId: createSelector(getAppState, function (state) { return state.eaqTopicMappedHesiExamByCourseId; }),
    getIsEAQTopicMappedHesiExamLoading: createSelector(getAppState, function (state) { return state.isEaqTopicMappedHesiExamLoading; }),
    getIsBackToPreviousAppIconShown: createSelector(getAppState, function (state) { return state.isBackToPreviousAppIconShown; }),
    getRedirectUrl: createSelector(getAppState, function (state) { return state.redirectUrl; }),
    getEaqTopicReportUrl: createSelector(getAppState, function (state) { return state.eaqTopicReportUrl; }),
    getLinkId: createSelector(getAppState, function (state) { return state.linkId; }),
    getFeatureFlags: createSelector(getAppState, function (state) { return state.featureFlags; }),
    getIsFeatureFlagsLoading: createSelector(getAppState, function (state) { return state.isFeatureFlagsLoading; }),
    getIsLaunchedFromAnotherApp: createSelector(getAppState, function (state) { return state.isLaunchedFromAnotherApp; }),
    getIsCWLinkHADAndEHRChecking: createSelector(getAppState, function (state) { return state.isCWLinkHADAndEHRChecking; }),
    getIsCWBentoBoxLinkShow: createSelector(getAppState, function (state) { return state.isCWBentoBoxLinkShow; }),
    getIsCWBentoBoxLinkLoading: createSelector(getAppState, function (state) { return state.isCWBentoBoxLinkLoading; }),
    getIsHADStudentDetailLinkShow: createSelector(getAppState, function (state) { return state.isHADStudentDetailLinkShow; }),
    getIsCWStudentDetailLinkShow: createSelector(getAppState, function (state) { return state.isCWStudentDetailLinkShow; }),
    getIsCWSubNavInEHRPageShow: createSelector(getAppState, function (state) { return state.isCWSubNavInEHRPageShow; }),
    getIsHADStudentDetailLinkFetching: createSelector(getAppState, function (state) { return state.isHADStudentDetailLinkFetching; }),
    getIsCWStudentDetailLinkFetching: createSelector(getAppState, function (state) { return state.isCWStudentDetailLinkFetching; }),
    getHADStudentDetailLink: createSelector(getAppState, function (state) { return state.hadStudentDetailLink; }),
    getCWStudentDetailLink: createSelector(getAppState, function (state) { return state.cwStudentDetailLink; }),
    getAppLinkOutPostBody: createSelector(getAppState, function (state) { return state.appLinkOutPostBody; }),
    getAppLinkNavigationInfo: createSelector(getAppState, function (state) { return state.appLinkNavigationInfo; }),
    getBentoBoxShown: createSelector(getAppState, function (state) { return state.bentoBoxShown; }),
    getEvolveUsername: createSelector(getAppState, function (state) { return state.evolveUsername; }),
    getBreadcrumbBackTitle: createSelector(getAppState, function (state) { return state.breadcrumbBackTitle; }),
    getIsEhrReportingEnabled: createSelector(getAppState, function (state) { return state.isEhrReportingEnabled; }),
    getIsNclexReportingEnabled: createSelector(getAppState, function (state) { return state.isNclexReportingEnabled; }),
    getIsShEnabled: createSelector(getAppState, function (state) { return state.isShEnabled; }),
    getIsProgramSolutionsEnabled: createSelector(getAppState, function (state) { return state.isProgramSolutionsEnabled; }),
    getIsEmergePackageEnabled: createSelector(getAppState, function (state) { return state.isEmergePackageEnabled; }),
    getIsLaunchedInNewTab: createSelector(getAppState, function (state) { return state.isLaunchedInNewTab; }),
    getSelectedExpandRowId: createSelector(getAppState, function (state) { return state.selectedExpandRowId; }),
    getEaqTopicMappedHesiExamByISBN: createSelector(getAppState, function (state) { return state.eaqTopicMappedHesiExamByISBN; }),
    getAllEolsUsers: createSelector(getAppState, function (state) { return state.allEolsUsers; }),
    getCatalog: createSelector(getAppState, function (state) { return state.catalog; }),
    getAssignments: createSelector(getAppState, function (state) { return state.assignments; }),
    getToggleExpandRowId: createSelector(getAppState, function (state) { return state.toggleExpandRowId; }),
    getIsAllAADataCollected: createSelector(getAppState, function (state) { return state.isAllAADataCollected; }),
    getCustomizationScore: createSelector(getAppState, function (state) { return state.customizationScore; }),
    getEcrId: createSelector(getAppState, function (state) { return state.ecrId; }),
    getUserEnhancedRoles: createSelector(getAppState, function (state) { return state.userEnhancedRoles; })
};
export { actions as appActions, initialState as appInitialState, reducer as appReducer, selectors as appSelectors };
